import { http } from "config/http";

export const getNotification = async () => {
    try {
        const res: any = await http.get(`get_notifications?client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const addNotifications = async (data: object) => {
    const destinationObject = { ...data, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.post('add_notifications', destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}


export const getNotificationById = async (id: any) => {
    try {
        const res: any = await http.get(`get_notification_by_id?notification_id=${id}&client_env=${localStorage.getItem("clientName")}`,)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const activeInActive = async (body: object) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.put('active_deactive_notifications', destinationObject);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const deleteNotifications = async (body: object) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.put('delete_notification', destinationObject);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const updateNotification = async (body: object) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.put('update_notification', destinationObject);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const currentNotification = async () => {
    try {
        const res: any = await http.get(`notification?client_env=${localStorage.getItem("clientName")}`);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}   